module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ad-wrapper"
  }, [_c('a', {
    attrs: {
      "href": _vm.adInfo.url,
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.adInfo.atturl,
      "alt": "ads"
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2811e52e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/home-page/banner-square/ads.vue
// module id = 1555
// module chunks = 1